// Sticky Add to Cart for Mobile - You Good Clothing
class StickyAddToCart extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    if (window.innerWidth >= 750) return; // Only for mobile

    const productForm = document.querySelector('.product-form');
    const addToCartButton = document.querySelector('.product-form__submit');

    if (!productForm || !addToCartButton) return;

    // Clone the add to cart button for sticky version
    this.createStickyButton(addToCartButton);

    // Set up scroll listener
    this.setupScrollListener(addToCartButton);
  }

  createStickyButton(originalButton) {
    const stickyButton = originalButton.cloneNode(true);
    stickyButton.classList.add('product-form__submit--sticky');
    stickyButton.id = 'sticky-atc-button';

    // Sync the button behavior with the original
    stickyButton.addEventListener('click', (e) => {
      e.preventDefault();
      originalButton.click();
    });

    document.body.appendChild(stickyButton);
    this.stickyButton = stickyButton;
  }

  setupScrollListener(originalButton) {
    let lastScrollTop = 0;
    const buttonRect = originalButton.getBoundingClientRect();
    const buttonOffsetTop = window.pageYOffset + buttonRect.top;

    window.addEventListener('scroll', () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      // Show sticky button when original is scrolled past
      if (scrollTop > buttonOffsetTop + buttonRect.height + 100) {
        this.stickyButton.classList.add('visible');
        document.body.classList.add('has-sticky-atc');
      } else {
        this.stickyButton.classList.remove('visible');
        document.body.classList.remove('has-sticky-atc');
      }

      lastScrollTop = scrollTop;
    });
  }
}

// Initialize on product pages
if (document.querySelector('.product-form')) {
  customElements.define('sticky-add-to-cart', StickyAddToCart);
  const stickyAtc = document.createElement('sticky-add-to-cart');
  document.body.appendChild(stickyAtc);
}
